import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import '@fontsource-variable/dm-sans/index.css';
import '@fontsource/dm-mono/400.css';
import '@fontsource/dm-mono/500.css';
import './i18n';
import './index.css';
import App from './App.tsx';
import { SettingsProvider } from './context/SettingsContext.tsx';
import { ToastProvider } from './context/ToastContext.tsx';
import { AuthProvider } from './context/AuthContext.tsx';

// Sentry initialiseres kun i production-builds — undgår støj fra lokal dev
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://10f1324a2c2e8efd4f4a4ab524e061f8@o4511293141221376.ingest.de.sentry.io/4511295809585232',
    sendDefaultPii: false,  // ingen IP/PII til Sentry (GDPR)
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
